<template>
  <div class="operationLog">
    <HearderTitle name="操作日志" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true">
          <el-form-item>
            <el-input v-model="queryInfo.pername" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item label="操作时间">
            <el-date-picker v-model="queryInfo.timest" prefix-icon=" " align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
            <span class="middle">到</span>
            <el-date-picker v-model="queryInfo.timeet" prefix-icon=" " align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="序号" width="180" align="center"> </el-table-column>
          <el-table-column prop="nickname" width="280" label="用户名" align="center"> </el-table-column>
          <el-table-column prop="time" width="280" label="操作时间" align="center"> </el-table-column>
          <el-table-column prop="ip" width="480" label="登录IP" align="center"> </el-table-column>
          <el-table-column prop="content" label="操作内容" align="left"> </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-size="queryInfo.pageSize" layout="total, prev, pager, next,jumper" :total="total" background> </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { operationLogList } from '@/api/user'
  import HearderTitle from '@/components/HearderTitle'
  export default {
    name: 'operationLog',
    data() {
      return {
        queryInfo: {
          // 姓名
          pername: '',
          timest: '',
          timeet: '',
          // 状态
          // 当前页
          pageNum: 1,
          // 每页数量
          pageSize: 12,
        },
        tableData: [],
        total: 0,
      }
    },
    created() {
      this.operationLogList()
    },
    methods: {
      // 监听当前页码的变化
      handleCurrentChange(newpagenum) {
        console.log('newpagenum: ', newpagenum)
        this.queryInfo.pageNum = newpagenum
        this.operationLogList()
      },
      async operationLogList() {
        let { list } = await operationLogList(this.queryInfo)
        this.tableData = list.data
        this.total = list.total
      },
      // 搜索
      search() {
        // 页码恢复第一页
        this.queryInfo.pageNum = 1
        this.operationLogList(this.queryInfo)
      },
    },
    components: { HearderTitle },
  }
</script>

<style lang="less">
  .operationLog {
    .tableBox {
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        padding-top: 28px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;
          .el-date-editor.el-input {
            width: 100px;
            height: 32px;
          }
          .el-input {
            .el-input__inner {
              width: 210px;
              height: 32px;
            }
            width: 220px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .el-input__inner,
          .el-date-editor.el-input {
            width: 100px;
            height: 32px;
          }
          .middle {
            padding: 0 10px;
          }
          .el-date-editor.el-input {
            width: 120px;
            .el-input__inner {
              width: 120px;
            }
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
</style>
